import { ListingType, WaitlistListingType } from '@libs/graphql/types'
import {
  SpaceTypeSlugs,
  UseCaseSlugs,
} from '@page/search/categories/search-categories.types'
import {
  SearchResultSpaceType,
  SearchResultUseCase,
} from '@page/search/search.graphql'

const spaceTypeAll: SearchResultSpaceType = {
  __typename: 'SearchSpaceType',
  listingCount: 0,
  spaceType: {
    __typename: 'SpaceType',
    name: 'All spaces',
    description: 'spaces',
    id: 0,
    slug: SpaceTypeSlugs.All,
    waitlistListingType: WaitlistListingType.POOL,
    listingType: ListingType.pool,
  },
}

const spaceTypePool: SearchResultSpaceType = {
  __typename: 'SearchSpaceType',
  listingCount: 0,
  spaceType: {
    __typename: 'SpaceType',
    name: 'Pool',
    description: 'pools',
    id: 0,
    slug: SpaceTypeSlugs.Pool,
    waitlistListingType: WaitlistListingType.POOL,
    listingType: ListingType.pool,
  },
}

const useCaseAnything: SearchResultUseCase = {
  __typename: 'SearchUseCase',
  listingCount: 0,
  useCase: {
    __typename: 'UseCase',
    name: 'All',
    id: 0,
    slug: UseCaseSlugs.All,
    waitlistable: false,
  },
}

export const categoriesConstants = {
  spaceTypeAll,
  spaceTypePool,
  useCaseAnything,
}
